import React, { useRef } from 'react';
import { TextField } from "@material-ui/core";

const CustomNumberField = ({ field, form, ...props }) => {
  const validationTimeoutRef = useRef();

  return (
    <TextField
      variant="outlined"
      fullWidth
      name={field.name}
      value={field.value}
      onBlur={() => form.setFieldTouched(field.name)}
      onChange={(event) => {
        if (/[^0-9]+/.exec(event.target.value)?.length > 0) {
          form.setFieldValue(field.name, event.target.dataset.oldValue ?? '');
        } else {
          form.setFieldValue(field.name, event.target.value);
          event.target.dataset.oldValue = event.target.value;
        }

        if (validationTimeoutRef.current) clearTimeout(validationTimeoutRef.current);
        validationTimeoutRef.current = setTimeout(() => form.setFieldTouched(field.name), 350);
      }}
      error={Boolean(form.errors[field.name])}
      helperText={form.errors[field.name]}
      {...props}
    />
  );
};

export default CustomNumberField;